import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import { stickyNav } from "../../../utils";
import { base_url } from "../../../services/configServices/config";

const HeaderAdminLayout = () => {
  const setting = useSelector((state) => state.meta?.setting);

  useEffect(() => {
    stickyNav();
  }, []);

  const [toggle, setToggle] = useState(false);

  const closeMenu = () => setToggle(false);

  useEffect(() => {
    if (document.querySelector("header").className.includes("animated")) {
      setTimeout(() => {
        document.querySelector("header").classList.add("opened", "show");
      }, 800);
    }
  }, [toggle]);

  const menuItems = (
    <div className="kf-main-menu">
      <ul>
        <li>
          <Link to="/" onClick={closeMenu}>
            خانه
          </Link>
        </li>
        <li>
          <Link to="/admin/user" onClick={closeMenu}>
            مدیریت کاربران
          </Link>
        </li>
        <li>
          <Link to="/admin/category" onClick={closeMenu}>
            مدیریت دسته بندی
          </Link>
        </li>
        <li>
          <Link to="/admin/menu" onClick={closeMenu}>
            مدیریت منو
          </Link>
        </li>
      </ul>
    </div>
  );

  const callButton = (
    <Link to="/auth/logout" className="kf-btn h-btn">
      <span>خروج از حساب کاربری</span>
    </Link>
  );

  const hours = (
    <div className="kf-h-group">
      <i className="la la-clock" /> <em>ساعات کار :</em> {setting?.morningShift}{" "}
      - {setting?.eveningShift}
    </div>
  );

  const social = (
    <div className="kf-h-social">
      {/* <a href="https://instagram.com/example" target="_blank">
        <i className="fab fa-instagram" />
      </a> */}
    </div>
  );

  const location = (
    <div className="kf-h-group">
      <i className="fas fa-map-marker-alt" /> <em>آدرس :</em>
      <span className="me-2">{setting?.address}</span>
    </div>
  );

  return (
    <header className={`kf-header ${toggle ? "animated" : ""}`}>
      <div className="kf-topline">
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4 align-right">
            {hours}
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4 align-center">
            {social}
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4 align-left">
            {location}
          </div>
        </div>
      </div>
      <div className="kf-navbar">
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 align-right">
            {/* logo */}
            <div className="kf-logo">
              <Link to="/">
                <img
                  src={base_url + setting?.logo}
                  alt={setting?.title}
                  className="rounded"
                />
              </Link>
            </div>
          </div>
          <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 align-center">
            {menuItems}
          </div>
          <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 align-left">
            <a
              href="#"
              className={`kf-menu-btn ${toggle ? "active" : ""}`}
              onClick={() => setToggle(!toggle)}
            >
              <span />
            </a>
            {callButton}
          </div>
        </div>
      </div>
      <div className="kf-navbar-mobile text-center d-flex flex-column justify-content-between align-items-center">
        <div>{menuItems}</div>
        <div className="kf-topline">
          <div>{hours}</div>
          <div>{location}</div>
          <div className="mt-4">{callButton}</div>
          <div className="mt-4">{social}</div>
        </div>
      </div>
    </header>
  );
};
export default HeaderAdminLayout;
